import React from 'react';
import { useDispatch } from 'react-redux';
import gql from 'graphql-tag';
import { hooks } from 'lib.front';
import { clientLog } from 'common/gqlClientes';
import { logVerificar, loadingModal, openMsg } from 'redux-app';

const verificarQ = gql`
{
   verificarIntra {
      codigo
      tipoDoc
      nroDoc
      nombre
      apPaterno
      apMaterno
      razonSocial
      usuario
      email
      telefono
      contacto
      fechaVigencia
   }
}
`;

export default function useVerificar() {
   // REDUX
   const dispatch = useDispatch();
   //CALLBACKS LOGIN
   function callbackProcesarData(data) {
      dispatch(logVerificar(data.verificarIntra));
   }

   function callbackLoading(loading) {
      dispatch(loadingModal(loading));
   }

   function callbackError(error) {
      dispatch(openMsg(JSON.stringify(error)));
      dispatch(logVerificar({}));
   }

   const [verificarCall] = hooks.useApolloLazyQ(
      verificarQ,
      {
         callbackProcesarData,
         callbackLoading,
         callbackError
      },
      {
         client: clientLog
      }
   );
   return verificarCall;
}
